import React from 'react';

const TaxDetails = ({ taxes, onChange }) => {
  return (
    <>
      <div className="form-group">
        <label htmlFor="cgst-rate">CGST Rate (%):</label>
        <input 
          type="number" 
          id="cgst-rate" 
          value={taxes.cgst}
          onChange={(e) => onChange('taxes', 'cgst', e.target.value)}
          min="0"
          max="100"
          step="0.01"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="sgst-rate">SGST Rate (%):</label>
        <input 
          type="number" 
          id="sgst-rate" 
          value={taxes.sgst}
          onChange={(e) => onChange('taxes', 'sgst', e.target.value)}
          min="0"
          max="100"
          step="0.01"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="igst-rate">IGST Rate (%):</label>
        <input 
          type="number" 
          id="igst-rate" 
          value={taxes.igst}
          onChange={(e) => onChange('taxes', 'igst', e.target.value)}
          min="0"
          max="100"
          step="0.01"
        />
      </div>
    </>
  );
};

export default TaxDetails;